/**
 * The users constants module houses users-specific configurations.
 *
 * @module routes.users.constants
 */

angular.module('routes.users.constants', [])
  .config([
    '$provide',
    function ($provide) {
      'use strict';

      // Define.
      var users;

      // Set defaults.
      users = {};

      /**
       * Defines users constants.
       *
       * @attribute USERS
       * @type String
       * @readOnly
       */
      $provide.constant('USERS', users);
    }
  ]);
